import React from "react";

import Tabs from "@arachnys/styleguide/Tabs";
import ProcessSummary from "../../container/ProcessSummary";
import NarrativeTable from "./NarrativeTable";
import DispositionTable from "./DispositionTable";

const ACCGProcessHistory = props => {
    const processId = atob(props.processRelayId).replace("Process:", "");
    const tabs = [
        {
            label: "Narrative",
            key: "narrative",
            content: (
                <NarrativeTable
                    processRelayId={props.processRelayId}
                    schema={props.schema}
                />
            ),
        },
        {
            label: "Full Results",
            key: "fullResults",
            content: (
                <>
                    <DispositionTable
                        processRelayId={props.processRelayId}
                        schema={props.schema}
                        dataPath="review"
                    />
                    <ProcessSummary
                        showUploader={false}
                        processId={processId}
                    />
                </>
            ),
        },
    ];

    return <Tabs defaultActiveKey="narrative" tabs={tabs} />;
};

export default ACCGProcessHistory;
